module.exports = __webpack_public_path__ + "img/screen-img-01.02f92e13.jpeg";